import { render, staticRenderFns } from "./B-3-1__BUPageCreate.vue?vue&type=template&id=4960a383&"
import script from "./B-3-1__BUPageCreate.vue?vue&type=script&lang=js&"
export * from "./B-3-1__BUPageCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports